<!-- ==========================================================================
     SISTEMAS DE ARCHIVOS
     ========================================================================== -->

<div class="container-fluid storage-page">

  <div class="storage-container">

    <!-- ======================================================================
         01. HEADER
         ====================================================================== -->

    <div class="storage-header">

      <div class="storage-header-main">

        <div class="storage-header-icon">
          <i class="fa-solid fa-database"></i>
        </div>

        <div class="storage-header-content">

          <span class="storage-eyebrow">
            ALMACENAMIENTO
          </span>

          <h4>
            Sistemas de archivos
          </h4>

          <p>
            Administra los sistemas de almacenamiento configurados
            para este servicio.
          </p>

        </div>

      </div>


      <!-- AGREGAR -->

      <button
        type="button"
        class="storage-add-button"
        (click)="
          openModal(
            createUser,
            'add',
            'Agregar Sistema de Archivos'
          )
        ">

        <i class="fa-solid fa-plus"></i>

        <span>
          Agregar sistema
        </span>

      </button>

    </div>


    <!-- ======================================================================
         02. INFORMACIÓN
         ====================================================================== -->

    <div class="storage-info">

      <div class="storage-info-main">

        <div class="storage-info-icon">
          <i class="fa-solid fa-hard-drive"></i>
        </div>

        <div>

          <strong>
            Almacenamientos configurados
          </strong>

          <span>
            Gestiona los proveedores y selecciona cuál será
            utilizado como predeterminado.
          </span>

        </div>

      </div>


      <div class="storage-counter">

        <span class="storage-counter-value">
          {{ totalItems || 0 }}
        </span>

        <span class="storage-counter-label">
          {{ totalItems === 1 ? 'configurado' : 'configurados' }}
        </span>

      </div>

    </div>


    <!-- ======================================================================
         03. TABLA
         ====================================================================== -->

    <div class="storage-table-section">

      <div class="storage-table-header">

        <div>

          <h5>
            Sistemas disponibles
          </h5>

          <p>
            Consulta y administra los sistemas de archivos registrados.
          </p>

        </div>

      </div>


      <div class="storage-table-wrapper">

        <app-paginacion
          [currentPage]="currentPage"
          [totalItems]="totalItems"
          [selectedPageSize]="pageSize"
          [paginatedData]="currentItems"
          [headers]="tableHeaders"
          [actions]="customActions"
          (pageChange)="onPageChange($event)"
          (pageSizeChange)="onPageSizeChange($event)"
          [loading]="spinner">
        </app-paginacion>

      </div>

    </div>

  </div>

</div>



<!-- ==========================================================================
     MODAL AGREGAR / EDITAR SISTEMA DE ARCHIVOS
     ========================================================================== -->

<ng-template #createUser let-modal>

  <div class="storage-modal">

    <!-- ======================================================================
         HEADER MODAL
         ====================================================================== -->

    <div class="storage-modal-header">

      <div class="storage-modal-title">

        <div class="storage-modal-icon">
          <i
            class="fa-solid"
            [ngClass]="idBucketP ? 'fa-pen-to-square' : 'fa-plus'">
          </i>
        </div>


        <div>

          <span class="storage-modal-eyebrow">
            SISTEMA DE ARCHIVOS
          </span>

          <h4>
            {{ title }}
          </h4>

          <p>
            Configura la información del sistema de almacenamiento.
          </p>

        </div>

      </div>


      <!-- CERRAR -->

      <button
        type="button"
        class="storage-modal-close"
        aria-label="Cerrar"
        (click)="modal.dismiss('Cross click')">

        <i class="fa-solid fa-xmark"></i>

      </button>

    </div>


    <!-- ======================================================================
         BODY MODAL
         ====================================================================== -->

    <div class="storage-modal-body">

      <app-bucket
        [idBucketP]="idBucketP"
        [idBucketDefault]="defaultBucket"
        (saved)="saved($event)">
      </app-bucket>

    </div>

  </div>

</ng-template>